module.exports = __webpack_public_path__ + "c09266e4335ce6ce49d30c7c28e58ddf.svg";